import { useEffect, useState } from 'react';
import { fetchVideoConfig } from '@/core/required-videos-api';
import type { RequiredVideoConfig } from '@/types/required-video';

type State = {
  config: RequiredVideoConfig | null;
  error: string | null;
  loading: boolean;
};

export function useVideoConfig(videoKey: string): State {
  const [state, setState] = useState<State>({
    config: null,
    error: null,
    loading: true,
  });

  useEffect(() => {
    let cancelled = false;
    setState({ config: null, error: null, loading: true });
    fetchVideoConfig(videoKey)
      .then((cfg) => {
        if (!cancelled) setState({ config: cfg, error: null, loading: false });
      })
      .catch((e: unknown) => {
        if (cancelled) return;
        const msg = e instanceof Error ? e.message : 'Config fetch failed';
        setState({ config: null, error: msg, loading: false });
      });
    return (): void => {
      cancelled = true;
    };
  }, [videoKey]);

  return state;
}
